module.exports = __webpack_public_path__ + "static/media/md-list.250f9d19.svg";